export default __webpack_public_path__ + "static/media/background-image.a2bb3cc7.webp";